<main>
  <gridster [options]="options">
    <gridster-item [item]="item" *ngFor="let item of dashboard">
      <div class="item">
        <div class="item__name">
          {{item['label']}}
        </div>

      </div>
    </gridster-item>
  </gridster>
  <div class="actions text-right">
    <button class="btn btn-primary btn-sm d-none" id="gridsterSaveBtn" (click)="saveCalculatedStyles()">{{'SAVE' |
      translate}}</button>
  </div>
</main>